import React from 'react';

function AccordionTitle(props){
	return <button className="dropbtn accordion-title">{props.title}</button>
}
export default AccordionTitle;